(function () {
  'use strict';

  // Loaded by any section that renders CWC_product_card. One delegated listener
  // covers every card on the page, including cards added later (load more, filters).
  if (window.cwcProductCardReady) return;
  window.cwcProductCardReady = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.classList || !form.classList.contains('cwc_product-card__form')) return;
    event.preventDefault();

    const button = form.querySelector('.cwc_product-card__button');
    const idInput = form.querySelector('input[name="id"]');
    if (!button || !idInput) return;

    const label = button.dataset.label || button.textContent;
    button.classList.add('cwc_product-card__button--loading');
    button.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function (added) {
        const item = added.items ? added.items[0] : added;
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            refreshThemeCart(cart, item);
            showButtonState(button, label, 'Added ✓', 'cwc_product-card__button--added');
            announce((item && item.product_title ? item.product_title : 'Item') + ' added to cart');
          });
      })
      .catch(function (error) {
        showButtonState(button, label, 'Unavailable', null);
        announce(error.message);
        document.dispatchEvent(new CustomEvent('cart:error', { detail: { errorMessage: error.message } }));
      })
      .finally(function () {
        button.classList.remove('cwc_product-card__button--loading');
        button.removeAttribute('aria-busy');
      });
  });

  function showButtonState(button, label, text, className) {
    button.textContent = text;
    if (className) button.classList.add(className);
    setTimeout(function () {
      button.textContent = label;
      if (className) button.classList.remove(className);
    }, 2000);
  }

  // Screen reader announcement (one shared live region)
  function announce(message) {
    let region = document.getElementById('cwc_product-card-status');
    if (!region) {
      region = document.createElement('p');
      region.id = 'cwc_product-card-status';
      region.setAttribute('role', 'status');
      region.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);margin:0';
      document.body.appendChild(region);
    }
    region.textContent = message;
  }

  // Hand the updated cart to the theme so its count + quick cart drawer refresh and open
  function refreshThemeCart(cart, item) {
    if (window.theme) window.theme.cartData = cart;

    if (typeof window.emit === 'function') {
      window.emit('cart:updated', { cart: cart });
    }

    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: item } }));
  }
})();
